export default __webpack_public_path__ + "static/media/different.dd88e022.jpg";